<template>
    <div class="login flex-center" :class="providerClasses">
        <v-card class="modal modal-round">
            <div class="logo-wrapper flex-center">
                <img :src="logoUrl" :class="{ 'logo-wifeed': usesNewLogo }" alt="wifeed-logo" class="logo" />
            </div>

            <form class="form" @submit="preventDefault">
                <v-text-field
                    v-model="password"
                    label="DEFINIR SENHA"
                    type="password"
                    class="font-lg"
                ></v-text-field>

                <v-text-field
                    v-model="passwordRepeat"
                    label="CONFIRME SUA SENHA"
                    type="password"
                    class="font-lg"
                ></v-text-field>

                <button
                    class="btn btn-primary btn-extra-round"
                    @click="submit"
                    @submit="preventDefault"
                >
                    Salvar
                </button>
            </form>
        </v-card>

        <vue-recaptcha
            @verify="onVerifyCaptcha"
            ref="recaptcha"
            size="invisible"
            :loadRecaptchaScript="true"
            sitekey="6LfD48YUAAAAAPJ2LiZ86AloaAMg5Yq9ZZQyo69-"
        >
        </vue-recaptcha>
    </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import EventBus from "@packages/event-bus";
import jwtDecode from "jwt-decode";
import provider from "@packages/mixins/provider";

export default {
    components: {
        VueRecaptcha,
    },
    data() {
        return {
            password: null,
            passwordRepeat: null,
            hash: "",
        };
    },

    computed: {
        user() {
            return this.$store.state.users.user;
        },

        admin() {
            return this.$store.state.users.admin;
        },
    },

    created() {
        this.checkHash();
        this.setWhitelabelClassOnBody();
    },

    methods: {
        onVerifyCaptcha: function (response) {
            this.submitLogin(response);
        },
        preventDefault(evt) {
            evt.preventDefault();
        },
        async submitLogin(keycaptcha) {
            await this.$auth.login({
                username: this.email,
                password: this.password,
                captcha: keycaptcha,
            });

            let userId;
            let userName;
            let userEmail;
            let userType;

            if (this.user) {
                const loginToken = jwtDecode(this.user.token);

                this.$store.commit("SET_USER", {
                    accountId: loginToken.accountId,
                    id: loginToken.userId,
                    login: loginToken.sub,
                    nome: loginToken.userName,
                    permissions: loginToken.permissions,
                    tipo: loginToken.accountType,
                });

                const isPartner =
                    loginToken.accountType === "PARCEIRO" ? true : false;
                this.$store.commit("SET_PARCEIRO", isPartner);

                userId = loginToken.userId;
                userName = loginToken.userName;
                userEmail = loginToken.sub;
                userType = loginToken.accountType;

                if (isPartner) {
                    this.$router.push("/estabelecimentos");
                } else {
                    this.$router.push("/visao-geral");
                }
            }

            if (this.admin) {
                const adminLoginToken = jwtDecode(this.admin.token);
                userId = 0;
                userName = adminLoginToken.userName;
                userEmail = adminLoginToken.sub;
                userType = "ADMIN";
                this.$router.push("/admin/estabelecimentos");
            }
        },
        async submit() {
            if (!this.password || !this.passwordRepeat) {
                EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: "Informe a senha e a confirmação",
                });
                return;
            }
            if (this.password != this.passwordRepeat) {
                EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: "Senhas não conferem",
                });
                return;
            }
            let response = await this.$api.accountRecovery.recoverPassword({
                hash: this.hash,
                password: this.password,
            });

            this.email = response;

            this.$refs.recaptcha.execute();

            EventBus.$emit("show-message", {
                type: "SUCCESS",
                message: "Senha redefinida com sucesso!",
                timeout: 3000,
            });
            // window.location.href = '/login'
        },
        async checkHash() {
            try {
                const res = await this.$api.accountRecovery.checkHash({
                    hash: this.$route.query.hash,
                });
                const isBoolean = typeof res === "boolean";

                const isValid = isBoolean ? res : res.data;

                this.hash = this.$route.query.hash;

                if (!isValid) {
                    EventBus.$emit("show-message", {
                        type: "ERROR",
                        message: "Esta operação não está mais disponivel",
                    });
                    setTimeout(() => {
                        window.location.href = "/login";
                    }, 200);
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
    mixins: [provider],
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.login {
    width: 100vw;
    height: 100vh;
    background: $primary;

    .modal {
        min-width: 500px;
        padding: 42px;

        .logo-wrapper {
            width: 100%;
            margin-bottom: 42px;
            flex: 1;

            .logo {
                height: 92px;

                &.logo-wifeed {
                    max-width: 197px;
                    height: auto;
                }
            }
        }

        .form {
            flex: 1;
            text-align: center;

            & > *:not(:last-child) {
                margin-bottom: 22px !important;
            }

            .btn {
                font-size: 18px;
                text-transform: uppercase;
                padding: 8px 42px;
            }
        }
    }

    .forgot-password {
        cursor: pointer;
    }

    &.login-wcs {
        background: rgb(255, 153, 0);
        background: linear-gradient(
            90deg,
            rgba(255, 153, 0, 1) 0%,
            rgba(243, 146, 0, 1) 50%,
            rgba(213, 118, 0, 1) 100%
        );
    }

    &.login-haggi {
        background: #2ebeb1;
    }

    &.login-tely {
        background: #0048fd;
    }

    &.login-ntcorp {
        background: #2e3b56;
    }

    &.login-vivo {
        background: #660099;

        .logo {
            width: 180px;
            height: 102px !important;
        }
    }

    &.login-vero {
        background: #29377f !important;
    }

    &.login-abc {
        background: #5f1319 !important;
    }

    &.login-unifique {
        background: #212492 !important;
    }
}
</style>
